import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { ChartData, ChartTimeFrame, Product, ProductImage } from '../models/product.model';
import { environment } from '../../../environments/environment';
import { OfferProduct } from '../models/offer-product.model';
import { StoreOffer } from '../models/store-offer';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private readonly http: HttpClient = inject(HttpClient);

  public searchProducts(searchText: string): Observable<OfferProduct[]> {
        return this.http
          .get<OfferProduct[]>(
            `${environment.backendUrl}/api/products/search`,
            { params: { searchText } }
          ).pipe(
            catchError((error) => {
              console.error('Search error:', error);
              return of([]);
            })
          );
    }

  public getProductDetails(slug: string): Observable<Product> {
    return this.http.get<Product>(`${environment.backendUrl}/api/products/${slug}`)
          .pipe(
            catchError((error) => {
              console.error('Failed to load product details:', error);
              return throwError(() => new Error('Failed to load product details'));
            })
          );
  }

  public getPopularProducts(): Observable<OfferProduct[]> {
    return this.http.get<OfferProduct[]>(`${environment.backendUrl}/api/products/search-top-ranked`)
    .pipe(
      catchError(error => {
        console.error('Failed to load popular products:', error);
        return of([]);
      })
    );
  }

  public getProductImages(slug: string): Observable<ProductImage[]> {
    return this.http.get<{content: ProductImage[]}>(`${environment.backendUrl}/api/products/${slug}/images`)
      .pipe(
        map(response => response.content),
        catchError(error => {
          console.error('Failed to load product images:', error);
          return of([]);
        })
      );
  }

  public getProductStoreOffers(productId: number): Observable<OfferProduct[]> {
    return this.http.get<OfferProduct[]>(`${environment.backendUrl}/api/products/${productId}/offers`)
      .pipe(
        catchError(error => {
          console.error('Failed to load product offers:', error);
          return of([]);
        })
      );
  }

  public getProductOfferHistory(productId: number, chartTimeFrame: ChartTimeFrame): Observable<ChartData[]> {
    return this.http.get<ChartData[]>(
      `${environment.backendUrl}/api/products/${productId}/offer_history`,
      {params: { chartTimeFrame }
    })
    .pipe(
      catchError(error => {
        console.error('Failed to load product offer history:', error);
        return of([]);
      })
    );
  }
}